import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import transaction from '@apis/transaction'
import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'
import Container from '@components/container'
import {
  Button,
  StatusCard,
  StatusIcon,
  StatusMessage,
  StatusTitle,
} from './style'

// Animations

const PaymentStatus = () => {
  const [debugInfo, setDebugInfo] = useState<string[]>([])
  const location = useLocation()
  const [status, setStatus] = useState<'pending' | 'success' | 'error'>(
    'pending',
  )
  const [message, setMessage] = useState('Processing your payment...')
  const navigate = useNavigate()

  // Parse query params
  const queryParams = new URLSearchParams(location.search)
  const requestId = queryParams.get('requestId')
  const method = queryParams.get('method')

  useEffect(() => {
    const verifyPayment = async () => {
      if (!requestId || !method) {
        setStatus('error')
        setMessage('Missing requestId or method.')
        setDebugInfo((prev) => [
          ...prev,
          'Missing requestId or method in query params.',
        ])
        return
      }

      const payload = {
        requestId,
        method,
      }

      setDebugInfo((prev) => [
        ...prev,
        `Sending payload: ${JSON.stringify(payload)}`,
      ])

      try {
        const res = await transaction.verifyPayment({ data: payload })

        setDebugInfo((prev) => [
          ...prev,
          `Response: ${JSON.stringify(res)}`,
          `Data: ${JSON.stringify(res?.data)}`,
          `Success: ${res?.data?.success}`,
        ])

        if (res.success) {
          setStatus('success')
          setMessage('Payment successful! Redirecting...')
          setTimeout(() => {
            window.location.href = `https://beta.tournaop.com/payment-status?type=success`
          }, 2000)
        } else {
          setStatus('error')
          setMessage('Payment verification failed. Redirecting...')
          setDebugInfo((prev) => [...prev, 'Payment verification failed.'])
          setTimeout(() => {
            window.location.href = `https://beta.tournaop.com/payment-status?type=failed`
          }, 2000)
        }
      } catch (err: any) {
        setStatus('error')
        setMessage('An error occurred. Redirecting...')
        setDebugInfo((prev) => [
          ...prev,
          `Caught Error: ${err?.message || 'Unknown error'}`,
        ])
        setTimeout(() => {
          window.location.href = `https://beta.tournaop.com/payment-status?type=failed`
        }, 2000)
      }
    }

    verifyPayment()
  }, [requestId, method, navigate])

  const getStatusIcon = () => {
    switch (status) {
      case 'success':
        return '✓'
      case 'error':
        return '✕'
      default:
        return '⟳'
    }
  }

  return (
    <Container>
      <StatusCard>
        <StatusIcon status={status}>{getStatusIcon()}</StatusIcon>
        <StatusTitle>Payment Status: {status.toUpperCase()}</StatusTitle>
        <StatusMessage>{message}</StatusMessage>

        {status !== 'pending' && (
          <Button onClick={() => navigate('/')}>Return Home</Button>
        )}
        {debugInfo.length > 0 && (
          <div style={{ marginTop: '2rem', textAlign: 'left' }}>
            <h3>Debug Info:</h3>
            <ul
              style={{
                maxHeight: '300px',
                overflowY: 'auto',
                padding: '0 1rem',
              }}
            >
              {debugInfo?.map((info, index) => (
                <li key={index} style={{ fontSize: '0.9rem', color: '#444' }}>
                  {info}
                </li>
              ))}
            </ul>
          </div>
        )}
      </StatusCard>
    </Container>
  )
}

export default PaymentStatus

//commit
